import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
}

export interface AccumulationGQL {
  __typename?: 'Accumulation';
  amount?: Maybe<Scalars['String']>;
  cignaCareNetwork?: Maybe<Scalars['Boolean']>;
  coveredServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  covers?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  met?: Maybe<Scalars['String']>;
  networkId?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  networkTierDisplayOrderCd?: Maybe<Scalars['String']>;
  networkTierDisplayOrderCdDescription?: Maybe<Scalars['String']>;
  networkTierLabelName?: Maybe<Scalars['String']>;
  networkType?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  planPeriodCode?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  remaining?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
  tierIndex?: Maybe<Scalars['String']>;
}

export interface AddressGQL {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  lines?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface AttachmentMetaDataGQL {
  __typename?: 'AttachmentMetaData';
  createdBy?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  domainId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  scanSignature?: Maybe<Scalars['String']>;
  scanStatus?: Maybe<AttachmentStatusTypeGQL>;
  signedUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
}

export enum AttachmentStatusTypeGQL {
  InvalidGQL = 'INVALID',
  NewGQL = 'NEW',
  UnavailableGQL = 'UNAVAILABLE',
  ValidGQL = 'VALID',
}

export interface BenefitReferenceNumberGQL {
  __typename?: 'BenefitReferenceNumber';
  asOfDate?: Maybe<Scalars['String']>;
  benefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  brn?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  coverage?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  detail?: Maybe<BenefitReferenceNumberDetailsGQL>;
  firstName?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  sso?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
}

export interface BenefitReferenceNumberDetailsGQL {
  __typename?: 'BenefitReferenceNumberDetails';
  subscriberDetails?: Maybe<PatientSubscriberDetailsGQL>;
}

export interface ClaimGQL {
  __typename?: 'Claim';
  amtBilled?: Maybe<Scalars['String']>;
  claimCompositeKey: Scalars['String'];
  claimReferenceNumber: Scalars['String'];
  claimReferenceNumberDisplay?: Maybe<Scalars['String']>;
  claimStatus?: Maybe<Scalars['String']>;
  compositeClaimId?: Maybe<Scalars['String']>;
  dateOfService?: Maybe<Scalars['String']>;
  detail?: Maybe<ClaimDetailGQL>;
  documentType?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  hasAttachments?: Maybe<Scalars['Boolean']>;
  hasReconsiderations?: Maybe<Scalars['Boolean']>;
  idCardExtension?: Maybe<Scalars['String']>;
  medicare?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientGQL>;
  patientDob?: Maybe<Scalars['String']>;
  patientFirstName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  patientLastName?: Maybe<Scalars['String']>;
  providerGenPatientAcct?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  remittanceSummaryData?: Maybe<RemittanceSummaryGQL>;
  tin: Scalars['String'];
}

export interface ClaimDetailGQL {
  __typename?: 'ClaimDetail';
  claimCompositeKey?: Maybe<Scalars['String']>;
  claimDetailErrorMessage?: Maybe<Scalars['String']>;
  claimInfoObject?: Maybe<ClaimInfoGQL>;
  isFlagged?: Maybe<Scalars['Boolean']>;
  medicare?: Maybe<Scalars['Boolean']>;
  memberObject?: Maybe<ClaimDetailMemberGQL>;
  reconsiderations?: Maybe<Array<Maybe<ReconsiderationGQL>>>;
  supportingInformation?: Maybe<Array<Maybe<SupportingInformationGQL>>>;
}

export interface ClaimDetailInputGQL {
  claimCompositeKey: Scalars['String'];
  claimReferenceNumber: Scalars['String'];
  compositeClaimId?: InputMaybe<Scalars['String']>;
  medicare?: InputMaybe<Scalars['Boolean']>;
  tinNumbers: Scalars['String'];
}

export interface ClaimDetailMemberGQL {
  __typename?: 'ClaimDetailMember';
  claimSystemCode?: Maybe<Scalars['String']>;
  hasBehavioral?: Maybe<Scalars['Boolean']>;
  hasRestrictedAccount?: Maybe<Scalars['Boolean']>;
  hasRestrictedGroup?: Maybe<Scalars['Boolean']>;
  isPayerSolution?: Maybe<Scalars['Boolean']>;
  isSharedAdmin?: Maybe<Scalars['Boolean']>;
  memberDateOfBirth?: Maybe<Scalars['String']>;
  memberFirstName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  memberIdentifier?: Maybe<Scalars['String']>;
  memberLastName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  relationShipCode?: Maybe<Scalars['String']>;
}

export interface ClaimDetailsInfoMessagesGQL {
  __typename?: 'ClaimDetailsInfoMessages';
  claimInfoText?: Maybe<Scalars['String']>;
}

export interface ClaimExplanationOfRemarkCodesGQL {
  __typename?: 'ClaimExplanationOfRemarkCodes';
  additionalDesc?: Maybe<Scalars['String']>;
  remarkCode?: Maybe<Scalars['String']>;
  remarkCodeDesc?: Maybe<Scalars['String']>;
}

export interface ClaimInfoGQL {
  __typename?: 'ClaimInfo';
  additionalRemarks?: Maybe<Scalars['String']>;
  ami?: Maybe<Scalars['String']>;
  claimAmountDue?: Maybe<Scalars['String']>;
  claimAmountPaid?: Maybe<Scalars['String']>;
  claimDateOfService?: Maybe<Scalars['String']>;
  claimDetailsInfoMessages?: Maybe<Array<Maybe<ClaimDetailsInfoMessagesGQL>>>;
  claimDrgUsedCode?: Maybe<Scalars['String']>;
  claimEngineClaimID?: Maybe<Scalars['String']>;
  claimProcessedDate?: Maybe<Scalars['String']>;
  claimReceivedDate?: Maybe<Scalars['String']>;
  claimReferenceNumber?: Maybe<Scalars['String']>;
  claimStatusCodes?: Maybe<Array<Maybe<ClaimsStatusCodeGQL>>>;
  claimStatusDesc?: Maybe<Scalars['String']>;
  claimTotChargeAmount?: Maybe<Scalars['String']>;
  claimTotPaidAmount?: Maybe<Scalars['String']>;
  compositeClaimId?: Maybe<Scalars['String']>;
  coverageCompositeKey?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  explanationOfRemarkCodes?: Maybe<
    Array<Maybe<ClaimExplanationOfRemarkCodesGQL>>
  >;
  firstName?: Maybe<Scalars['String']>;
  footNoteMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
  fsaAmount?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  haaAmount?: Maybe<Scalars['String']>;
  hasReconAccess?: Maybe<Scalars['Boolean']>;
  hfAmount?: Maybe<Scalars['String']>;
  hraAmount?: Maybe<Scalars['String']>;
  hsaAmount?: Maybe<Scalars['String']>;
  idCardExtensionCode?: Maybe<Scalars['String']>;
  internallyPended?: Maybe<Scalars['String']>;
  isBehavioral?: Maybe<Scalars['Boolean']>;
  isDDAR?: Maybe<Scalars['Boolean']>;
  isDOSEstimate?: Maybe<Scalars['Boolean']>;
  isWebster?: Maybe<Scalars['Boolean']>;
  isZelis?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lpAmount?: Maybe<Scalars['String']>;
  networkPPOIndicator?: Maybe<Scalars['String']>;
  overPaidClaimsInfo?: Maybe<Array<Maybe<OverpaidClaimsInfoGQL>>>;
  patientResponsibility?: Maybe<Scalars['String']>;
  payeeInfo?: Maybe<Array<Maybe<PayeeInfoGQL>>>;
  payeePaymentInfoMessages?: Maybe<Array<Maybe<PayeePaymentInfoMessagesGQL>>>;
  paymentInfoMessages?: Maybe<Array<Maybe<PaymentInfoMessagesGQL>>>;
  paymentProviderAmt?: Maybe<Scalars['String']>;
  providerGeneratedAccountNumber?: Maybe<Scalars['String']>;
  recoupedAmount?: Maybe<Scalars['String']>;
  remarkCodes?: Maybe<Array<Maybe<RemarkCodeGQL>>>;
  serviceLineInfoArray?: Maybe<Array<Maybe<ClaimServiceLineInfoGQL>>>;
  serviceLineTotalsObject?: Maybe<ServiceLineTotalGQL>;
  serviceProvider?: Maybe<Scalars['String']>;
  showPaymentInfo?: Maybe<Scalars['Boolean']>;
  sourceSystemCode?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
}

export interface ClaimSearchInputGQL {
  claimReferenceNumber?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ClaimSearchInputFiltersGQL>;
  memberDateOfBirth?: InputMaybe<Scalars['String']>;
  memberFirstName?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['String']>;
  memberLastName?: InputMaybe<Scalars['String']>;
  officeName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientSearchType?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortOn?: InputMaybe<Scalars['String']>;
  tinNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
}

export interface ClaimSearchInputFilterChargesGQL {
  chargeMax?: InputMaybe<Scalars['Int']>;
  chargeMin?: InputMaybe<Scalars['Int']>;
  chargeType: Scalars['String'];
}

export interface ClaimSearchInputFilterDateGQL {
  dateMax?: InputMaybe<Scalars['String']>;
  dateMin?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<Scalars['String']>;
  dateType?: InputMaybe<Scalars['String']>;
}

export interface ClaimSearchInputFiltersGQL {
  charges?: InputMaybe<ClaimSearchInputFilterChargesGQL>;
  date?: InputMaybe<ClaimSearchInputFilterDateGQL>;
  other?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface ClaimSearchInputSortGQL {
  active?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
}

export interface ClaimSearchResponseGQL {
  __typename?: 'ClaimSearchResponse';
  claims?: Maybe<Array<Maybe<ClaimGQL>>>;
  total?: Maybe<Scalars['Int']>;
}

export interface ClaimServiceLineInfoGQL {
  __typename?: 'ClaimServiceLineInfo';
  allowedAmount?: Maybe<Scalars['String']>;
  amountCharged?: Maybe<Scalars['String']>;
  amountNotAllowed?: Maybe<Scalars['String']>;
  amountNotCovered?: Maybe<Scalars['String']>;
  cdtCode?: Maybe<Scalars['String']>;
  copay?: Maybe<Scalars['String']>;
  coveredBalance?: Maybe<Scalars['String']>;
  dateOfService?: Maybe<Scalars['String']>;
  deductible?: Maybe<Scalars['String']>;
  fsaPayment?: Maybe<Scalars['String']>;
  haPayment?: Maybe<Scalars['String']>;
  hraPayment?: Maybe<Scalars['String']>;
  hsaPayment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDOSEstimate?: Maybe<Scalars['Boolean']>;
  memberCoInsu?: Maybe<Scalars['String']>;
  memberCoInsurancePer?: Maybe<Scalars['String']>;
  memberResponsibility?: Maybe<Scalars['String']>;
  patientCoinsuranceResponsibility?: Maybe<Scalars['String']>;
  placeOfService?: Maybe<Scalars['String']>;
  planCoInsurancePer?: Maybe<Scalars['String']>;
  procedureCode?: Maybe<Scalars['String']>;
  propRemarkDescription?: Maybe<Scalars['String']>;
  remarkCode?: Maybe<Scalars['String']>;
  serviceLineApcCode?: Maybe<Scalars['String']>;
  svcLineContractedAmount?: Maybe<Scalars['String']>;
  svcLinePaidAmount?: Maybe<Scalars['String']>;
  toothNumber?: Maybe<Scalars['String']>;
}

export enum ClaimStatusGQL {
  AdjustedGQL = 'ADJUSTED',
  ApprovedGQL = 'APPROVED',
  DeniedGQL = 'DENIED',
  DuplicateGQL = 'DUPLICATE',
  InProcessGQL = 'IN_PROCESS',
  PaidGQL = 'PAID',
  PendedGQL = 'PENDED',
  PendingGQL = 'PENDING',
  ProcessedGQL = 'PROCESSED',
  RejectedGQL = 'REJECTED',
}

export interface ClaimsStatusCodeGQL {
  __typename?: 'ClaimsStatusCode';
  reasonCodeDesc?: Maybe<Scalars['String']>;
  reasonCodeValue?: Maybe<Scalars['String']>;
  statusCodeDesc?: Maybe<Scalars['String']>;
  statusCodeValue?: Maybe<Scalars['String']>;
}

export interface CobDetailGQL {
  __typename?: 'CobDetail';
  carrier?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Scalars['String']>;
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  primacy?: Maybe<Scalars['String']>;
  verifiedOn?: Maybe<Scalars['String']>;
}

export interface ContactGQL {
  __typename?: 'Contact';
  addresses?: Maybe<Array<Maybe<AddressGQL>>>;
  name?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<PhoneGQL>>>;
  type?: Maybe<Scalars['String']>;
}

export interface CsnDetailGQL {
  __typename?: 'CsnDetail';
  csnId?: Maybe<Scalars['String']>;
  displayOrderCd?: Maybe<Scalars['String']>;
  displayOrderDesc?: Maybe<Scalars['String']>;
  tierName?: Maybe<Scalars['String']>;
}

export interface CsnNetworkDetailsGQL {
  __typename?: 'CsnNetworkDetails';
  csnNetwork?: Maybe<Array<Maybe<CsnDetailGQL>>>;
}

export interface DashboardClaimMemberInputGQL {
  memberFirstName: Scalars['String'];
  memberId: Scalars['String'];
  memberLastName: Scalars['String'];
}

export interface DashboardClaimSummaryInputGQL {
  chargeAmount: Scalars['String'];
  claimCompositeKey: Scalars['String'];
  claimReferenceNumber: Scalars['String'];
  claimStatus: Scalars['String'];
  compositeClaimId?: InputMaybe<Scalars['String']>;
  dateOfService: Scalars['String'];
  medicare: Scalars['Boolean'];
  providerGeneratedAccountNumber: Scalars['String'];
}

export interface DashboardPatientCoverageInputGQL {
  account?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  compositeKey?: InputMaybe<Scalars['String']>;
  coverageFrom?: InputMaybe<Scalars['String']>;
  coverageStatus?: InputMaybe<Scalars['String']>;
  coverageTo?: InputMaybe<Scalars['String']>;
  coverageType?: InputMaybe<Scalars['String']>;
  isEffectivelyTermed?: InputMaybe<Scalars['Boolean']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  showLink?: InputMaybe<Scalars['Boolean']>;
}

export interface EcnNetworkDetailsGQL {
  __typename?: 'EcnNetworkDetails';
  csnNetworkDetails?: Maybe<CsnNetworkDetailsGQL>;
  ecnId?: Maybe<Scalars['String']>;
}

export interface FlagClaimInputGQL {
  claimSummary: DashboardClaimSummaryInputGQL;
  dateFlagged: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  member: DashboardClaimMemberInputGQL;
  tinNumbers: Array<InputMaybe<Scalars['String']>>;
}

export interface FlagPatientInputGQL {
  ami?: InputMaybe<Scalars['String']>;
  asOfDate?: InputMaybe<Scalars['String']>;
  coverage?: InputMaybe<DashboardPatientCoverageInputGQL>;
  dateFlagged?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
}

export enum FlagTypeGQL {
  AGQL = 'A',
  DGQL = 'D',
}

export interface FlaggedClaimGQL {
  __typename?: 'FlaggedClaim';
  claimSummary?: Maybe<FlaggedClaimSummaryGQL>;
  dateFlagged?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  member?: Maybe<FlaggedClaimMemberGQL>;
  tinNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface FlaggedClaimMemberGQL {
  __typename?: 'FlaggedClaimMember';
  memberFirstName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  memberLastName?: Maybe<Scalars['String']>;
}

export interface FlaggedClaimSummaryGQL {
  __typename?: 'FlaggedClaimSummary';
  chargeAmount?: Maybe<Scalars['String']>;
  claimCompositeKey?: Maybe<Scalars['String']>;
  claimReferenceNumber?: Maybe<Scalars['String']>;
  claimStatus?: Maybe<Scalars['String']>;
  compositeClaimId?: Maybe<Scalars['String']>;
  dateOfService?: Maybe<Scalars['String']>;
  medicare?: Maybe<Scalars['Boolean']>;
  providerGeneratedAccountNumber?: Maybe<Scalars['String']>;
}

export interface FlaggedPatientGQL {
  __typename?: 'FlaggedPatient';
  ami?: Maybe<Scalars['String']>;
  asOfDate?: Maybe<Scalars['String']>;
  coverage?: Maybe<FlaggedPatientCoverageGQL>;
  dateFlagged?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
}

export interface FlaggedPatientCoverageGQL {
  __typename?: 'FlaggedPatientCoverage';
  account?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  coverageFrom?: Maybe<Scalars['String']>;
  coverageStatus?: Maybe<Scalars['String']>;
  coverageTo?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Scalars['String']>;
  isEffectivelyTermed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  showLink?: Maybe<Scalars['Boolean']>;
}

export interface HmoDetailsGQL {
  __typename?: 'HmoDetails';
  code?: Maybe<Scalars['String']>;
  contact?: Maybe<ContactGQL>;
  lob?: Maybe<Scalars['String']>;
  networkDesc?: Maybe<Scalars['String']>;
  networkId?: Maybe<Scalars['String']>;
  networkIdCode?: Maybe<Scalars['String']>;
  networkLob?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
}

export enum LobGQL {
  BehGQL = 'BEH',
  DenGQL = 'DEN',
  FdohpGQL = 'FDOHP',
  MedGQL = 'MED',
  MedbhGQL = 'MEDBH',
}

export interface MedicareDetailsGQL {
  __typename?: 'MedicareDetails';
  cobDetails?: Maybe<Array<Maybe<CobDetailGQL>>>;
  contractNumber?: Maybe<Scalars['String']>;
  egwpIndicator?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  healthPlanName?: Maybe<Scalars['String']>;
  operationalMarket?: Maybe<Scalars['String']>;
  pcpRequired?: Maybe<Scalars['String']>;
  planBenefitPackageNumber?: Maybe<Scalars['String']>;
  regulatoryMarket?: Maybe<Scalars['String']>;
  segmentNumber?: Maybe<Scalars['String']>;
  specialNeedPlanType?: Maybe<Scalars['String']>;
}

export interface MutationGQL {
  __typename?: 'Mutation';
  echo: Scalars['String'];
  flagClaimsUpdate?: Maybe<Array<Maybe<FlaggedClaimGQL>>>;
  flagPatientsUpdate?: Maybe<Array<Maybe<FlaggedPatientGQL>>>;
  remittanceMarkRead?: Maybe<RemittanceMarkAsReadResponseGQL>;
  saveRecentClaim?: Maybe<RecentClaimGQL>;
}

export interface MutationEchoArgsGQL {
  message: Scalars['String'];
}

export interface MutationFlagClaimsUpdateArgsGQL {
  claims: Array<InputMaybe<FlagClaimInputGQL>>;
  type: FlagTypeGQL;
}

export interface MutationFlagPatientsUpdateArgsGQL {
  patients: Array<InputMaybe<FlagPatientInputGQL>>;
  type: FlagTypeGQL;
}

export interface MutationRemittanceMarkReadArgsGQL {
  input?: InputMaybe<RemittanceMarkAsReadInputGQL>;
}

export interface MutationSaveRecentClaimArgsGQL {
  claim: RecentClaimInputGQL;
}

export interface NetworkDetailsGQL {
  __typename?: 'NetworkDetails';
  baseNetworkId?: Maybe<Scalars['String']>;
  dnspEligible?: Maybe<Scalars['String']>;
  ecnNetworkDetails?: Maybe<EcnNetworkDetailsGQL>;
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  hmoDetails?: Maybe<HmoDetailsGQL>;
  iCareNetworkId?: Maybe<Scalars['String']>;
  inOutIndicator?: Maybe<Scalars['String']>;
  isAllegianceMember?: Maybe<Scalars['Boolean']>;
  isHAPMember?: Maybe<Scalars['Boolean']>;
  isNetworkTiered?: Maybe<Scalars['Boolean']>;
  mpoId?: Maybe<Scalars['String']>;
  mpoName?: Maybe<Scalars['String']>;
  networkId?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  networkType?: Maybe<Scalars['String']>;
  npoId?: Maybe<Scalars['String']>;
  npoName?: Maybe<Scalars['String']>;
  pcp?: Maybe<PcpStatusGQL>;
  porgId?: Maybe<Scalars['String']>;
  seamlessIndicator?: Maybe<Scalars['String']>;
  superNetworkId?: Maybe<Scalars['String']>;
  tier?: Maybe<TierGQL>;
}

export interface OverpaidClaimsInfoGQL {
  __typename?: 'OverpaidClaimsInfo';
  claimPaidDate?: Maybe<Scalars['String']>;
  claimReferenceNumber?: Maybe<Scalars['String']>;
  patientAccountNumber?: Maybe<Scalars['String']>;
  recoupmentAmount?: Maybe<Scalars['String']>;
  recoupmentBalance?: Maybe<Scalars['String']>;
}

export interface PartnerGQL {
  __typename?: 'Partner';
  coordinatingParty?: Maybe<Scalars['String']>;
  effectiveOn?: Maybe<Scalars['String']>;
  endsOn?: Maybe<Scalars['String']>;
  roleOfCigna?: Maybe<Scalars['String']>;
  supportingParty?: Maybe<Scalars['String']>;
  thirdPartyAdmin?: Maybe<Scalars['String']>;
}

export interface PatientGQL {
  __typename?: 'Patient';
  asOfDate: Scalars['String'];
  brnHistory?: Maybe<Array<Maybe<BenefitReferenceNumberGQL>>>;
  claims?: Maybe<Array<Maybe<ClaimGQL>>>;
  compositeKey: Scalars['String'];
  coverageType: Scalars['String'];
  detail?: Maybe<PatientDetailGQL>;
  dob?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  planLevelAccumulation?: Maybe<Array<Maybe<PlanLevelAccumGQL>>>;
  primaryCareDetails?: Maybe<PcpDetailsGQL>;
}

export interface PatientClaimsArgsGQL {
  status?: InputMaybe<Array<InputMaybe<ClaimStatusGQL>>>;
}

export interface PatientDetailArgsGQL {
  input?: InputMaybe<PcpDetailsInputGQL>;
}

export interface PatientPlanLevelAccumulationArgsGQL {
  input?: InputMaybe<PlanLevelAccumInputGQL>;
}

export interface PatientPrimaryCareDetailsArgsGQL {
  input?: InputMaybe<PcpDetailsInputGQL>;
}

export interface PatientAllianceGQL {
  __typename?: 'PatientAlliance';
  hasMVP?: Maybe<Scalars['Boolean']>;
  partners?: Maybe<Array<Maybe<PartnerGQL>>>;
}

export interface PatientCompositeKeyInputGQL {
  asOfDate: Scalars['String'];
  compositeKey: Scalars['String'];
  coverageType: Scalars['String'];
}

export interface PatientCoverageGQL {
  __typename?: 'PatientCoverage';
  account?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  coverageFrom?: Maybe<Scalars['String']>;
  coverageStatus?: Maybe<Scalars['String']>;
  coverageTo?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Scalars['String']>;
  effectivelyTermed?: Maybe<Scalars['Boolean']>;
  groupNumber?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  showLink?: Maybe<Scalars['Boolean']>;
}

export interface PatientCoverageDetailGQL {
  __typename?: 'PatientCoverageDetail';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  claimSystemCode?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  coverageStatus?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Scalars['String']>;
  coverages?: Maybe<Array<Maybe<Scalars['String']>>>;
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  erisaApplicable?: Maybe<Scalars['Boolean']>;
  hasBayCareGroup?: Maybe<Scalars['Boolean']>;
  hasCSN?: Maybe<Scalars['Boolean']>;
  hasConflictingStatus?: Maybe<Scalars['Boolean']>;
  hasCoveredBenefits?: Maybe<Scalars['Boolean']>;
  hasIFP?: Maybe<Scalars['Boolean']>;
  hasMHSR?: Maybe<Scalars['Boolean']>;
  hasMultipleActive?: Maybe<Scalars['Boolean']>;
  hasPDP?: Maybe<Scalars['Boolean']>;
  hasPRN?: Maybe<Scalars['Boolean']>;
  initialCoverageDate?: Maybe<Scalars['String']>;
  isAccountRestricted?: Maybe<Scalars['Boolean']>;
  isMultipleCoverage?: Maybe<Scalars['Boolean']>;
  medicalManagementPlan?: Maybe<Scalars['String']>;
  medicare?: Maybe<MedicareDetailsGQL>;
  networkDescription?: Maybe<Scalars['String']>;
  networkDetails?: Maybe<NetworkDetailsGQL>;
  ohip?: Maybe<Scalars['String']>;
  otherInsurance?: Maybe<Scalars['String']>;
  otherInsuranceVerifiedOn?: Maybe<Scalars['String']>;
  pediatricInd?: Maybe<Scalars['String']>;
  plan?: Maybe<PatientPlanGQL>;
  referralCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  umAuthSystem?: Maybe<Scalars['String']>;
  utilizationDataNotAvlble?: Maybe<Scalars['Boolean']>;
}

export interface PatientDetailGQL {
  __typename?: 'PatientDetail';
  alliances?: Maybe<PatientAllianceGQL>;
  cobDetails?: Maybe<Array<Maybe<CobDetailGQL>>>;
  coverageDetails?: Maybe<PatientCoverageDetailGQL>;
  patientDetails?: Maybe<PatientInformationGQL>;
  productDetails?: Maybe<PatientProductDetailGQL>;
  serviceContact?: Maybe<Array<Maybe<PatientServiceContactGQL>>>;
  subscriberDetails?: Maybe<PatientSubscriberDetailsGQL>;
}

export interface PatientIdDobInputGQL {
  dateOfBirth: Scalars['String'];
  id: Scalars['String'];
}

export interface PatientInformationGQL {
  __typename?: 'PatientInformation';
  addresses?: Maybe<Array<Maybe<AddressGQL>>>;
  dob?: Maybe<Scalars['String']>;
  eligibleForCostEstimation?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idCardExtensionCode?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  internalProcessingId?: Maybe<Scalars['String']>;
  isInternationalMember?: Maybe<Scalars['Boolean']>;
  isPolicyHolder?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
}

export interface PatientNameDobInputGQL {
  dateOfBirth: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export interface PatientPlanGQL {
  __typename?: 'PatientPlan';
  benefitOption?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  classNumber?: Maybe<Scalars['String']>;
  deductibleSequence?: Maybe<Scalars['String']>;
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  fundingType?: Maybe<Scalars['String']>;
  isIndemnity?: Maybe<Scalars['Boolean']>;
  pathwellIndicator?: Maybe<Scalars['String']>;
  planVariationIdentifier?: Maybe<Scalars['String']>;
  planYears?: Maybe<PatientPlanYearsGQL>;
  progressiveRegressiveInd?: Maybe<Scalars['String']>;
  rxCarveOutVendor?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface PatientPlanYearsGQL {
  __typename?: 'PatientPlanYears';
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  renewalType?: Maybe<Scalars['String']>;
}

export interface PatientProductDetailGQL {
  __typename?: 'PatientProductDetail';
  embeddedProducts?: Maybe<Array<Maybe<PatientProductEmbeddedGQL>>>;
  familyCode?: Maybe<Scalars['String']>;
  hasFSA?: Maybe<Scalars['Boolean']>;
  hasHRA?: Maybe<Scalars['Boolean']>;
  hasHSA?: Maybe<Scalars['Boolean']>;
  hraFundBalance?: Maybe<Scalars['String']>;
  isIFP?: Maybe<Scalars['Boolean']>;
  isV2V?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
}

export interface PatientProductEmbeddedGQL {
  __typename?: 'PatientProductEmbedded';
  effectiveOn?: Maybe<Scalars['String']>;
  endsOn?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
}

export interface PatientServiceContactGQL {
  __typename?: 'PatientServiceContact';
  addresses?: Maybe<Array<Maybe<AddressGQL>>>;
  effectiveDate?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<PhoneGQL>>>;
  type?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
  webName?: Maybe<Scalars['String']>;
}

export interface PatientSubscriberDetailsGQL {
  __typename?: 'PatientSubscriberDetails';
  dob?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  internalProcessingId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
}

export interface PayeeInfoGQL {
  __typename?: 'PayeeInfo';
  checkAmount?: Maybe<Scalars['String']>;
  checkClearedDate?: Maybe<Scalars['String']>;
  checkIssuedDate?: Maybe<Scalars['String']>;
  checkNumber?: Maybe<Scalars['String']>;
  checkStatus?: Maybe<Scalars['String']>;
  chkExists?: Maybe<Scalars['Boolean']>;
  eftExists?: Maybe<Scalars['Boolean']>;
  payeeAddress?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  remittanceNumber?: Maybe<Scalars['String']>;
  sourceDataKey?: Maybe<Scalars['String']>;
}

export interface PayeePaymentInfoMessagesGQL {
  __typename?: 'PayeePaymentInfoMessages';
  paymentInfoText?: Maybe<Scalars['String']>;
}

export interface PaymentInfoMessagesGQL {
  __typename?: 'PaymentInfoMessages';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface PaymentVendorGQL {
  __typename?: 'PaymentVendor';
  cancelDate?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
}

export interface PcpDetailsGQL {
  __typename?: 'PcpDetails';
  hasPCP?: Maybe<Scalars['Boolean']>;
  pcpStatus?: Maybe<Scalars['String']>;
  primaryCarePhysician?: Maybe<PrimaryCareServiceGQL>;
  providerOrganization?: Maybe<ProviderOrganizationGQL>;
}

export interface PcpDetailsInputGQL {
  idType: Scalars['String'];
  networkId?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
}

export interface PcpStatusGQL {
  __typename?: 'PcpStatus';
  assignmentType?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  hasPCP?: Maybe<Scalars['Boolean']>;
  pcpStatus?: Maybe<Scalars['String']>;
  providerIdentity?: Maybe<ProviderIdentityGQL>;
}

export interface PhoneGQL {
  __typename?: 'Phone';
  number?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface PlanLevelAccumGQL {
  __typename?: 'PlanLevelAccum';
  benefits?: Maybe<PlanLevelAccumBenefitsGQL>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
}

export interface PlanLevelAccumBenefitsGQL {
  __typename?: 'PlanLevelAccumBenefits';
  coinsurance?: Maybe<PlanLevelAccumDetailGQL>;
  deductible?: Maybe<PlanLevelAccumDetailGQL>;
  lifeTimeMaximum?: Maybe<PlanLevelAccumDetailGQL>;
  moop?: Maybe<PlanLevelAccumDetailGQL>;
  outOfPocketMaximum?: Maybe<PlanLevelAccumDetailGQL>;
}

export interface PlanLevelAccumDetailGQL {
  __typename?: 'PlanLevelAccumDetail';
  accumulations?: Maybe<Array<Maybe<AccumulationGQL>>>;
}

export interface PlanLevelAccumInputGQL {
  healthplanDigitalBenefitId: Scalars['String'];
}

export interface PrimaryCareServiceGQL {
  __typename?: 'PrimaryCareService';
  addresses?: Maybe<Array<Maybe<AddressGQL>>>;
  assignmentType?: Maybe<Scalars['String']>;
  effectiveFrom?: Maybe<Scalars['String']>;
  effectiveTill?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<PhoneGQL>>>;
}

export interface ProviderGQL {
  __typename?: 'Provider';
  cancellationDate?: Maybe<Scalars['String']>;
  contracted?: Maybe<Scalars['Boolean']>;
  effectiveDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tinId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface ProviderIdentityGQL {
  __typename?: 'ProviderIdentity';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

export interface ProviderOrganizationGQL {
  __typename?: 'ProviderOrganization';
  addresses?: Maybe<Array<Maybe<AddressGQL>>>;
  assignmentType?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Maybe<PhoneGQL>>>;
  serviceTypeCode?: Maybe<Scalars['String']>;
}

export interface QueryGQL {
  __typename?: 'Query';
  claimByCompositeKey?: Maybe<ClaimGQL>;
  claimByReferenceNumber?: Maybe<ClaimGQL>;
  claimSearch?: Maybe<ClaimSearchResponseGQL>;
  flaggedClaims?: Maybe<Array<Maybe<FlaggedClaimGQL>>>;
  flaggedPatients?: Maybe<Array<Maybe<FlaggedPatientGQL>>>;
  getClaimDetail?: Maybe<ClaimDetailGQL>;
  patientByCompositeKey?: Maybe<PatientGQL>;
  patientByIdDob?: Maybe<PatientGQL>;
  patientByNameDob?: Maybe<PatientGQL>;
  ping?: Maybe<Scalars['String']>;
  recentClaims?: Maybe<Array<Maybe<RecentClaimGQL>>>;
  recentPatients?: Maybe<Array<Maybe<RecentPatientGQL>>>;
  tinById?: Maybe<TinGQL>;
  tins?: Maybe<Array<Maybe<TinGQL>>>;
  user?: Maybe<UserProfileGQL>;
  wamDashboardUsers?: Maybe<WamQueryGQL>;
}

export interface QueryClaimByCompositeKeyArgsGQL {
  input?: InputMaybe<ClaimDetailInputGQL>;
}

export interface QueryClaimByReferenceNumberArgsGQL {
  input: Scalars['String'];
}

export interface QueryClaimSearchArgsGQL {
  input: ClaimSearchInputGQL;
}

export interface QueryGetClaimDetailArgsGQL {
  input?: InputMaybe<ClaimDetailInputGQL>;
}

export interface QueryPatientByCompositeKeyArgsGQL {
  input: PatientCompositeKeyInputGQL;
}

export interface QueryPatientByIdDobArgsGQL {
  input: PatientIdDobInputGQL;
}

export interface QueryPatientByNameDobArgsGQL {
  input: PatientNameDobInputGQL;
}

export interface QueryTinByIdArgsGQL {
  input: Scalars['String'];
}

export interface QueryTinsArgsGQL {
  contracted?: InputMaybe<Scalars['Boolean']>;
  lob?: InputMaybe<Array<InputMaybe<LobGQL>>>;
}

export interface QueryWamDashboardUsersArgsGQL {
  input?: InputMaybe<WamUserSearchInputGQL>;
}

export interface RecentClaimGQL {
  __typename?: 'RecentClaim';
  claimSummary?: Maybe<RecentClaimSummaryGQL>;
  member?: Maybe<RecentClaimMemberGQL>;
  tinNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface RecentClaimInputGQL {
  claimSummary: RecentClaimSummaryInputGQL;
  member: RecentClaimMemberInputGQL;
  tinNumbers: Array<InputMaybe<Scalars['String']>>;
}

export interface RecentClaimMemberGQL {
  __typename?: 'RecentClaimMember';
  claimSystemCode?: Maybe<Scalars['String']>;
  memberFirstName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  memberIdentifier?: Maybe<Scalars['String']>;
  memberLastName?: Maybe<Scalars['String']>;
  memberSearchKey?: Maybe<Scalars['String']>;
  relationShipCode?: Maybe<Scalars['String']>;
}

export interface RecentClaimMemberInputGQL {
  claimSystemCode: Scalars['String'];
  memberFirstName: Scalars['String'];
  memberId: Scalars['String'];
  memberIdentifier: Scalars['String'];
  memberLastName: Scalars['String'];
  memberSearchKey: Scalars['String'];
  relationShipCode: Scalars['String'];
}

export interface RecentClaimSummaryGQL {
  __typename?: 'RecentClaimSummary';
  chargeAmount?: Maybe<Scalars['String']>;
  claimCompositeKey?: Maybe<Scalars['String']>;
  claimReferenceNumber?: Maybe<Scalars['String']>;
  claimStatus?: Maybe<Scalars['String']>;
  claimType?: Maybe<Scalars['String']>;
  compositeClaimId?: Maybe<Scalars['String']>;
  dateOfService?: Maybe<Scalars['String']>;
  dateProcessed?: Maybe<Scalars['String']>;
  dateReceived?: Maybe<Scalars['String']>;
  medicare?: Maybe<Scalars['Boolean']>;
  providerGeneratedAccountNumber?: Maybe<Scalars['String']>;
}

export interface RecentClaimSummaryInputGQL {
  chargeAmount: Scalars['String'];
  claimCompositeKey: Scalars['String'];
  claimReferenceNumber: Scalars['String'];
  claimStatus: Scalars['String'];
  claimType?: InputMaybe<Scalars['String']>;
  compositeClaimId?: InputMaybe<Scalars['String']>;
  dateOfService: Scalars['String'];
  dateProcessed?: InputMaybe<Scalars['String']>;
  dateReceived?: InputMaybe<Scalars['String']>;
  medicare?: InputMaybe<Scalars['Boolean']>;
  providerGeneratedAccountNumber: Scalars['String'];
}

export interface RecentPatientGQL {
  __typename?: 'RecentPatient';
  ami?: Maybe<Scalars['String']>;
  asOfDate?: Maybe<Scalars['String']>;
  coverage?: Maybe<RecentPatientCoverageGQL>;
  dob?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
}

export interface RecentPatientCoverageGQL {
  __typename?: 'RecentPatientCoverage';
  account?: Maybe<Scalars['String']>;
  claimSystem?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  coverageFrom?: Maybe<Scalars['String']>;
  coverageStatus?: Maybe<Scalars['String']>;
  coverageTo?: Maybe<Scalars['String']>;
  coverageType?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  isEffectivelyTermed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  showLink?: Maybe<Scalars['Boolean']>;
}

export interface ReconsiderationGQL {
  __typename?: 'Reconsideration';
  choiceOne?: Maybe<Scalars['Int']>;
  choiceThree?: Maybe<Scalars['Int']>;
  choiceTwo?: Maybe<Scalars['Int']>;
  extRefNum?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
}

export interface RemarkCodeGQL {
  __typename?: 'RemarkCode';
  desc?: Maybe<Scalars['String']>;
  remarkCode?: Maybe<Scalars['String']>;
}

export interface RemittanceDataGQL {
  __typename?: 'RemittanceData';
  controlStr?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['String']>;
  dataPowerLink?: Maybe<Scalars['String']>;
  ddarMaxpages?: Maybe<Scalars['Int']>;
  depositAmount?: Maybe<Scalars['String']>;
  depositDate?: Maybe<Scalars['String']>;
  docId?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  documentTypeStr?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  generatedDate?: Maybe<Scalars['String']>;
  links?: Maybe<Scalars['Int']>;
  mbrDateofBirth?: Maybe<Scalars['String']>;
  mbrFirstName?: Maybe<Scalars['String']>;
  mbrLastName?: Maybe<Scalars['String']>;
  npiList?: Maybe<Array<Maybe<Scalars['String']>>>;
  numberOfPages?: Maybe<Scalars['Int']>;
  pagesList?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentDate?: Maybe<Scalars['String']>;
  processedDate?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  readRemittance?: Maybe<Scalars['Boolean']>;
  remittanceTrackingNumber?: Maybe<Scalars['String']>;
  reportCategory?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
}

export interface RemittanceMarkAsReadInputGQL {
  createDt?: InputMaybe<Scalars['String']>;
  readStatus: Scalars['Boolean'];
  trackingNo: Scalars['String'];
}

export interface RemittanceMarkAsReadResponseGQL {
  __typename?: 'RemittanceMarkAsReadResponse';
  trackingNo?: Maybe<Scalars['String']>;
}

export interface RemittanceSummaryGQL {
  __typename?: 'RemittanceSummary';
  isNPINumber?: Maybe<Scalars['Boolean']>;
  remittanceData?: Maybe<Array<Maybe<RemittanceDataGQL>>>;
}

export interface ServiceLineTotalGQL {
  __typename?: 'ServiceLineTotal';
  allowedAmountTotal?: Maybe<Scalars['String']>;
  amountChargedTotal?: Maybe<Scalars['String']>;
  amountNotCoveredTotal?: Maybe<Scalars['String']>;
  coPayTotal?: Maybe<Scalars['String']>;
  contractedAmountTotal?: Maybe<Scalars['String']>;
  coordinationBenefitTotal?: Maybe<Scalars['String']>;
  coveredBalTotal?: Maybe<Scalars['String']>;
  deductibleTotal?: Maybe<Scalars['String']>;
  memberCoInsuTotal?: Maybe<Scalars['String']>;
  memberResponseTotal?: Maybe<Scalars['String']>;
  paidFromFSATotal?: Maybe<Scalars['String']>;
  paidFromHATotal?: Maybe<Scalars['String']>;
  paidFromHRATotal?: Maybe<Scalars['String']>;
  paidFromHSATotal?: Maybe<Scalars['String']>;
  planCoinsurancePaidTotal?: Maybe<Scalars['String']>;
}

export interface SupportingInformationGQL {
  __typename?: 'SupportingInformation';
  attachments?: Maybe<Array<Maybe<Scalars['String']>>>;
  attachmentsData?: Maybe<Array<Maybe<AttachmentMetaDataGQL>>>;
  claimEngineClaimID?: Maybe<Scalars['String']>;
  claimReferenceNumber?: Maybe<Scalars['String']>;
  extRefNum?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourceSystemCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<UserBaseGQL>;
  submittedDate?: Maybe<Scalars['String']>;
}

export interface TierGQL {
  __typename?: 'Tier';
  tier1?: Maybe<Scalars['String']>;
  tier2?: Maybe<Scalars['String']>;
}

export interface TinGQL {
  __typename?: 'Tin';
  addrnLine1?: Maybe<Scalars['String']>;
  addrnLine2?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  contracted?: Maybe<Scalars['Boolean']>;
  countryName?: Maybe<Scalars['String']>;
  entitlements?: Maybe<Array<Maybe<Scalars['String']>>>;
  generatedTinId?: Maybe<Scalars['String']>;
  paymentVendors?: Maybe<Array<Maybe<PaymentVendorGQL>>>;
  phNo?: Maybe<Scalars['String']>;
  phNoExtn?: Maybe<Scalars['String']>;
  providers?: Maybe<Array<Maybe<ProviderGQL>>>;
  stateCode?: Maybe<Scalars['String']>;
  tinId?: Maybe<Scalars['String']>;
  tinLob?: Maybe<Scalars['String']>;
  tinName?: Maybe<Scalars['String']>;
  tinType?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zipCodePreFix?: Maybe<Scalars['String']>;
}

export interface UserBaseGQL {
  __typename?: 'UserBase';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
}

export interface UserProfileGQL {
  __typename?: 'UserProfile';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  alertType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dn?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isClaims360PopupSuppressed?: Maybe<Scalars['String']>;
  jobRoles?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lobPref?: Maybe<Scalars['String']>;
  migrated?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobileVerified?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtn?: Maybe<Scalars['String']>;
  pilotUsrInd?: Maybe<Scalars['String']>;
  secPwdLastChangedDate?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  userAgreementInd?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface WamEntitlementsForUserGQL {
  __typename?: 'WamEntitlementsForUser';
  id?: Maybe<Scalars['String']>;
  lob?: Maybe<Scalars['String']>;
  lobPref?: Maybe<Scalars['String']>;
  tins?: Maybe<Array<Maybe<WamUserTinGQL>>>;
}

export interface WamQueryGQL {
  __typename?: 'WamQuery';
  total?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<WamUserGQL>>>;
}

export interface WamUserGQL {
  __typename?: 'WamUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  jobRole?: Maybe<Scalars['String']>;
  jobRoleId?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  lob?: Maybe<Scalars['String']>;
  lobPref?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  requestedDate?: Maybe<Scalars['String']>;
  temporaryPassword?: Maybe<Scalars['String']>;
  temporaryUserName?: Maybe<Scalars['String']>;
  tins?: Maybe<Array<Maybe<WamUserTinGQL>>>;
  tinsWithEntitlements?: Maybe<Array<Maybe<WamUserTinWithEntitlementGQL>>>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
}

export interface WamUserEntitlementGQL {
  __typename?: 'WamUserEntitlement';
  description?: Maybe<Scalars['String']>;
  functions?: Maybe<Array<Maybe<WamUserFunctionGQL>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}

export interface WamUserFunctionGQL {
  __typename?: 'WamUserFunction';
  name?: Maybe<Scalars['String']>;
}

export interface WamUserSearchInputGQL {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface WamUserTinGQL {
  __typename?: 'WamUserTin';
  lob?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
}

export interface WamUserTinWithEntitlementGQL {
  __typename?: 'WamUserTinWithEntitlement';
  entitlements?: Maybe<Array<Maybe<WamUserEntitlementGQL>>>;
  lob?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
}

export type DashboardClaimsQueryVariablesGQL = Exact<{ [key: string]: never }>;

export type DashboardClaimsQueryGQL = {
  __typename?: 'Query';
  recentClaims?: Array<{
    __typename?: 'RecentClaim';
    tinNumbers?: Array<string | null> | null;
    member?: {
      __typename?: 'RecentClaimMember';
      memberId?: string | null;
      memberFirstName?: string | null;
      memberLastName?: string | null;
    } | null;
    claimSummary?: {
      __typename?: 'RecentClaimSummary';
      chargeAmount?: string | null;
      claimCompositeKey?: string | null;
      claimReferenceNumber?: string | null;
      compositeClaimId?: string | null;
      claimStatus?: string | null;
      dateOfService?: string | null;
      medicare?: boolean | null;
      providerGeneratedAccountNumber?: string | null;
    } | null;
  } | null> | null;
  flaggedClaims?: Array<{
    __typename?: 'FlaggedClaim';
    id?: string | null;
    tinNumbers?: Array<string | null> | null;
    dateFlagged?: string | null;
    member?: {
      __typename?: 'FlaggedClaimMember';
      memberId?: string | null;
      memberFirstName?: string | null;
      memberLastName?: string | null;
    } | null;
    claimSummary?: {
      __typename?: 'FlaggedClaimSummary';
      chargeAmount?: string | null;
      claimCompositeKey?: string | null;
      claimReferenceNumber?: string | null;
      compositeClaimId?: string | null;
      claimStatus?: string | null;
      dateOfService?: string | null;
      medicare?: boolean | null;
      providerGeneratedAccountNumber?: string | null;
    } | null;
  } | null> | null;
};

export type ClaimDetailQueryVariablesGQL = Exact<{
  input: ClaimDetailInputGQL;
}>;

export type ClaimDetailQueryGQL = {
  __typename?: 'Query';
  getClaimDetail?: {
    __typename?: 'ClaimDetail';
    claimCompositeKey?: string | null;
    medicare?: boolean | null;
    isFlagged?: boolean | null;
    claimDetailErrorMessage?: string | null;
    memberObject?: {
      __typename?: 'ClaimDetailMember';
      memberId?: string | null;
      memberDateOfBirth?: string | null;
      memberFirstName?: string | null;
      memberLastName?: string | null;
      relationShipCode?: string | null;
      memberIdentifier?: string | null;
      claimSystemCode?: string | null;
      hasBehavioral?: boolean | null;
      hasRestrictedAccount?: boolean | null;
      hasRestrictedGroup?: boolean | null;
      isPayerSolution?: boolean | null;
      isSharedAdmin?: boolean | null;
      notes?: string | null;
      patientId?: string | null;
    } | null;
    claimInfoObject?: {
      __typename?: 'ClaimInfo';
      serviceProvider?: string | null;
      claimDateOfService?: string | null;
      claimTotChargeAmount?: string | null;
      claimReferenceNumber?: string | null;
      compositeClaimId?: string | null;
      groupNumber?: string | null;
      coverageCompositeKey?: string | null;
      uploadUrl?: string | null;
      isWebster?: boolean | null;
      isDDAR?: boolean | null;
      isDOSEstimate?: boolean | null;
      claimEngineClaimID?: string | null;
      networkPPOIndicator?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      dateOfBirth?: string | null;
      ssn?: string | null;
      ami?: string | null;
      idCardExtensionCode?: string | null;
      providerGeneratedAccountNumber?: string | null;
      isBehavioral?: boolean | null;
      claimReceivedDate?: string | null;
      claimProcessedDate?: string | null;
      claimDrgUsedCode?: string | null;
      patientResponsibility?: string | null;
      claimTotPaidAmount?: string | null;
      additionalRemarks?: string | null;
      footNoteMessages?: Array<string | null> | null;
      isZelis?: boolean | null;
      showPaymentInfo?: boolean | null;
      hasReconAccess?: boolean | null;
      claimAmountDue?: string | null;
      recoupedAmount?: string | null;
      claimAmountPaid?: string | null;
      paymentProviderAmt?: string | null;
      hsaAmount?: string | null;
      hraAmount?: string | null;
      fsaAmount?: string | null;
      haaAmount?: string | null;
      hfAmount?: string | null;
      lpAmount?: string | null;
      claimStatusDesc?: string | null;
      sourceSystemCode?: string | null;
      claimDetailsInfoMessages?: Array<{
        __typename?: 'ClaimDetailsInfoMessages';
        claimInfoText?: string | null;
      } | null> | null;
      remarkCodes?: Array<{
        __typename?: 'RemarkCode';
        remarkCode?: string | null;
        desc?: string | null;
      } | null> | null;
      claimStatusCodes?: Array<{
        __typename?: 'ClaimsStatusCode';
        statusCodeValue?: string | null;
        statusCodeDesc?: string | null;
        reasonCodeValue?: string | null;
        reasonCodeDesc?: string | null;
      } | null> | null;
      overPaidClaimsInfo?: Array<{
        __typename?: 'OverpaidClaimsInfo';
        claimReferenceNumber?: string | null;
        patientAccountNumber?: string | null;
        claimPaidDate?: string | null;
        recoupmentAmount?: string | null;
        recoupmentBalance?: string | null;
      } | null> | null;
      payeeInfo?: Array<{
        __typename?: 'PayeeInfo';
        eftExists?: boolean | null;
        chkExists?: boolean | null;
        payeeName?: string | null;
        payeeAddress?: string | null;
        checkAmount?: string | null;
        checkNumber?: string | null;
        checkStatus?: string | null;
        checkIssuedDate?: string | null;
        checkClearedDate?: string | null;
        paymentMethod?: string | null;
        sourceDataKey?: string | null;
        remittanceNumber?: string | null;
      } | null> | null;
      payeePaymentInfoMessages?: Array<{
        __typename?: 'PayeePaymentInfoMessages';
        paymentInfoText?: string | null;
      } | null> | null;
      paymentInfoMessages?: Array<{
        __typename?: 'PaymentInfoMessages';
        label?: string | null;
        value?: string | null;
      } | null> | null;
      serviceLineInfoArray?: Array<{
        __typename?: 'ClaimServiceLineInfo';
        id?: number | null;
        isDOSEstimate?: boolean | null;
        dateOfService?: string | null;
        cdtCode?: string | null;
        procedureCode?: string | null;
        toothNumber?: string | null;
        amountCharged?: string | null;
        svcLineContractedAmount?: string | null;
        svcLinePaidAmount?: string | null;
        placeOfService?: string | null;
        allowedAmount?: string | null;
        serviceLineApcCode?: string | null;
        amountNotCovered?: string | null;
        deductible?: string | null;
        coveredBalance?: string | null;
        planCoInsurancePer?: string | null;
        memberCoInsurancePer?: string | null;
        memberCoInsu?: string | null;
        memberResponsibility?: string | null;
        patientCoinsuranceResponsibility?: string | null;
        copay?: string | null;
        remarkCode?: string | null;
        propRemarkDescription?: string | null;
        hraPayment?: string | null;
        hsaPayment?: string | null;
        fsaPayment?: string | null;
        haPayment?: string | null;
        amountNotAllowed?: string | null;
      } | null> | null;
      serviceLineTotalsObject?: {
        __typename?: 'ServiceLineTotal';
        amountChargedTotal?: string | null;
        allowedAmountTotal?: string | null;
        amountNotCoveredTotal?: string | null;
        deductibleTotal?: string | null;
        coveredBalTotal?: string | null;
        contractedAmountTotal?: string | null;
        coordinationBenefitTotal?: string | null;
        planCoinsurancePaidTotal?: string | null;
        coPayTotal?: string | null;
        memberCoInsuTotal?: string | null;
        memberResponseTotal?: string | null;
        paidFromHATotal?: string | null;
        paidFromHSATotal?: string | null;
        paidFromHRATotal?: string | null;
        paidFromFSATotal?: string | null;
      } | null;
      explanationOfRemarkCodes?: Array<{
        __typename?: 'ClaimExplanationOfRemarkCodes';
        remarkCode?: string | null;
        remarkCodeDesc?: string | null;
        additionalDesc?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type ClaimDetailNewQueryVariablesGQL = Exact<{
  input: ClaimDetailInputGQL;
}>;

export type ClaimDetailNewQueryGQL = {
  __typename?: 'Query';
  claimByCompositeKey?: {
    __typename?: 'Claim';
    remittanceSummaryData?: {
      __typename?: 'RemittanceSummary';
      isNPINumber?: boolean | null;
      remittanceData?: Array<{
        __typename?: 'RemittanceData';
        documentType?: string | null;
        remittanceTrackingNumber?: string | null;
        creationDate?: string | null;
        paymentDate?: string | null;
        processedDate?: string | null;
        generatedDate?: string | null;
        reportCategory?: string | null;
        readRemittance?: boolean | null;
        taxId?: string | null;
        npiList?: Array<string | null> | null;
        depositDate?: string | null;
        depositAmount?: string | null;
        mbrLastName?: string | null;
        mbrFirstName?: string | null;
        mbrDateofBirth?: string | null;
        productType?: string | null;
        expirationDate?: string | null;
        documentTypeStr?: string | null;
        numberOfPages?: number | null;
        links?: number | null;
        pagesList?: Array<string | null> | null;
        dataPowerLink?: string | null;
        docId?: string | null;
        controlStr?: string | null;
        ddarMaxpages?: number | null;
      } | null> | null;
    } | null;
    detail?: {
      __typename?: 'ClaimDetail';
      claimCompositeKey?: string | null;
      medicare?: boolean | null;
      isFlagged?: boolean | null;
      claimDetailErrorMessage?: string | null;
      memberObject?: {
        __typename?: 'ClaimDetailMember';
        memberId?: string | null;
        memberDateOfBirth?: string | null;
        memberFirstName?: string | null;
        memberLastName?: string | null;
        relationShipCode?: string | null;
        memberIdentifier?: string | null;
        claimSystemCode?: string | null;
        hasBehavioral?: boolean | null;
        hasRestrictedAccount?: boolean | null;
        hasRestrictedGroup?: boolean | null;
        isPayerSolution?: boolean | null;
        isSharedAdmin?: boolean | null;
        notes?: string | null;
        patientId?: string | null;
      } | null;
      claimInfoObject?: {
        __typename?: 'ClaimInfo';
        serviceProvider?: string | null;
        claimDateOfService?: string | null;
        claimTotChargeAmount?: string | null;
        claimReferenceNumber?: string | null;
        compositeClaimId?: string | null;
        groupNumber?: string | null;
        coverageCompositeKey?: string | null;
        uploadUrl?: string | null;
        isWebster?: boolean | null;
        isDDAR?: boolean | null;
        isDOSEstimate?: boolean | null;
        claimEngineClaimID?: string | null;
        networkPPOIndicator?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        dateOfBirth?: string | null;
        ssn?: string | null;
        ami?: string | null;
        idCardExtensionCode?: string | null;
        providerGeneratedAccountNumber?: string | null;
        isBehavioral?: boolean | null;
        claimReceivedDate?: string | null;
        claimProcessedDate?: string | null;
        claimDrgUsedCode?: string | null;
        patientResponsibility?: string | null;
        claimTotPaidAmount?: string | null;
        additionalRemarks?: string | null;
        footNoteMessages?: Array<string | null> | null;
        isZelis?: boolean | null;
        showPaymentInfo?: boolean | null;
        hasReconAccess?: boolean | null;
        claimAmountDue?: string | null;
        recoupedAmount?: string | null;
        claimAmountPaid?: string | null;
        paymentProviderAmt?: string | null;
        hsaAmount?: string | null;
        hraAmount?: string | null;
        fsaAmount?: string | null;
        haaAmount?: string | null;
        hfAmount?: string | null;
        lpAmount?: string | null;
        claimStatusDesc?: string | null;
        sourceSystemCode?: string | null;
        internallyPended?: string | null;
        claimDetailsInfoMessages?: Array<{
          __typename?: 'ClaimDetailsInfoMessages';
          claimInfoText?: string | null;
        } | null> | null;
        remarkCodes?: Array<{
          __typename?: 'RemarkCode';
          remarkCode?: string | null;
          desc?: string | null;
        } | null> | null;
        claimStatusCodes?: Array<{
          __typename?: 'ClaimsStatusCode';
          statusCodeValue?: string | null;
          statusCodeDesc?: string | null;
          reasonCodeValue?: string | null;
          reasonCodeDesc?: string | null;
        } | null> | null;
        overPaidClaimsInfo?: Array<{
          __typename?: 'OverpaidClaimsInfo';
          claimReferenceNumber?: string | null;
          patientAccountNumber?: string | null;
          claimPaidDate?: string | null;
          recoupmentAmount?: string | null;
          recoupmentBalance?: string | null;
        } | null> | null;
        payeeInfo?: Array<{
          __typename?: 'PayeeInfo';
          eftExists?: boolean | null;
          chkExists?: boolean | null;
          payeeName?: string | null;
          payeeAddress?: string | null;
          checkAmount?: string | null;
          checkNumber?: string | null;
          checkStatus?: string | null;
          checkIssuedDate?: string | null;
          checkClearedDate?: string | null;
          paymentMethod?: string | null;
          sourceDataKey?: string | null;
          remittanceNumber?: string | null;
        } | null> | null;
        payeePaymentInfoMessages?: Array<{
          __typename?: 'PayeePaymentInfoMessages';
          paymentInfoText?: string | null;
        } | null> | null;
        paymentInfoMessages?: Array<{
          __typename?: 'PaymentInfoMessages';
          label?: string | null;
          value?: string | null;
        } | null> | null;
        serviceLineInfoArray?: Array<{
          __typename?: 'ClaimServiceLineInfo';
          id?: number | null;
          isDOSEstimate?: boolean | null;
          dateOfService?: string | null;
          cdtCode?: string | null;
          procedureCode?: string | null;
          toothNumber?: string | null;
          amountCharged?: string | null;
          svcLineContractedAmount?: string | null;
          svcLinePaidAmount?: string | null;
          placeOfService?: string | null;
          allowedAmount?: string | null;
          serviceLineApcCode?: string | null;
          amountNotCovered?: string | null;
          deductible?: string | null;
          coveredBalance?: string | null;
          planCoInsurancePer?: string | null;
          memberCoInsurancePer?: string | null;
          memberCoInsu?: string | null;
          memberResponsibility?: string | null;
          patientCoinsuranceResponsibility?: string | null;
          copay?: string | null;
          remarkCode?: string | null;
          propRemarkDescription?: string | null;
          hraPayment?: string | null;
          hsaPayment?: string | null;
          fsaPayment?: string | null;
          haPayment?: string | null;
          amountNotAllowed?: string | null;
        } | null> | null;
        serviceLineTotalsObject?: {
          __typename?: 'ServiceLineTotal';
          amountChargedTotal?: string | null;
          allowedAmountTotal?: string | null;
          amountNotCoveredTotal?: string | null;
          deductibleTotal?: string | null;
          coveredBalTotal?: string | null;
          contractedAmountTotal?: string | null;
          coordinationBenefitTotal?: string | null;
          planCoinsurancePaidTotal?: string | null;
          coPayTotal?: string | null;
          memberCoInsuTotal?: string | null;
          memberResponseTotal?: string | null;
          paidFromHATotal?: string | null;
          paidFromHSATotal?: string | null;
          paidFromHRATotal?: string | null;
          paidFromFSATotal?: string | null;
        } | null;
        explanationOfRemarkCodes?: Array<{
          __typename?: 'ClaimExplanationOfRemarkCodes';
          remarkCode?: string | null;
          remarkCodeDesc?: string | null;
          additionalDesc?: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type DashboardPatientsQueryVariablesGQL = Exact<{
  [key: string]: never;
}>;

export type DashboardPatientsQueryGQL = {
  __typename?: 'Query';
  recentPatients?: Array<{
    __typename?: 'RecentPatient';
    ami?: string | null;
    asOfDate?: string | null;
    dob?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    identifier?: string | null;
    patientId?: string | null;
    coverage?: {
      __typename?: 'RecentPatientCoverage';
      account?: string | null;
      clientName?: string | null;
      compositeKey?: string | null;
      coverageFrom?: string | null;
      coverageStatus?: string | null;
      coverageTo?: string | null;
      coverageType?: string | null;
      isEffectivelyTermed?: boolean | null;
      isInactive?: boolean | null;
      showLink?: boolean | null;
    } | null;
  } | null> | null;
  flaggedPatients?: Array<{
    __typename?: 'FlaggedPatient';
    ami?: string | null;
    asOfDate?: string | null;
    dateFlagged?: string | null;
    dob?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    patientId?: string | null;
    coverage?: {
      __typename?: 'FlaggedPatientCoverage';
      account?: string | null;
      clientName?: string | null;
      compositeKey?: string | null;
      coverageFrom?: string | null;
      coverageStatus?: string | null;
      coverageTo?: string | null;
      coverageType?: string | null;
      isEffectivelyTermed?: boolean | null;
      isInactive?: boolean | null;
      showLink?: boolean | null;
    } | null;
  } | null> | null;
};

export type FlaggedPatientIdsQueryVariablesGQL = Exact<{
  [key: string]: never;
}>;

export type FlaggedPatientIdsQueryGQL = {
  __typename?: 'Query';
  flaggedPatients?: Array<{
    __typename?: 'FlaggedPatient';
    coverage?: {
      __typename?: 'FlaggedPatientCoverage';
      compositeKey?: string | null;
    } | null;
  } | null> | null;
};

export type FlaggedClaimIdsQueryVariablesGQL = Exact<{ [key: string]: never }>;

export type FlaggedClaimIdsQueryGQL = {
  __typename?: 'Query';
  flaggedClaims?: Array<{
    __typename?: 'FlaggedClaim';
    id?: string | null;
    claimSummary?: {
      __typename?: 'FlaggedClaimSummary';
      claimReferenceNumber?: string | null;
    } | null;
  } | null> | null;
};

export type DashboardWamUsersQueryVariablesGQL = Exact<{
  input?: InputMaybe<WamUserSearchInputGQL>;
}>;

export type DashboardWamUsersQueryGQL = {
  __typename?: 'Query';
  wamDashboardUsers?: {
    __typename?: 'WamQuery';
    total?: number | null;
    users?: Array<{
      __typename?: 'WamUser';
      firstName?: string | null;
      lastName?: string | null;
      id?: string | null;
      temporaryUserName?: string | null;
      temporaryPassword?: string | null;
      email?: string | null;
      phone?: string | null;
      jobRole?: string | null;
      tins?: Array<{
        __typename?: 'WamUserTin';
        tin?: string | null;
        name?: string | null;
        status?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type DashboardWamUserDetailQueryVariablesGQL = Exact<{
  input: WamUserSearchInputGQL;
}>;

export type DashboardWamUserDetailQueryGQL = {
  __typename?: 'Query';
  wamDashboardUsers?: {
    __typename?: 'WamQuery';
    users?: Array<{
      __typename?: 'WamUser';
      firstName?: string | null;
      lastName?: string | null;
      id?: string | null;
      tinsWithEntitlements?: Array<{
        __typename?: 'WamUserTinWithEntitlement';
        tin?: string | null;
        name?: string | null;
        status?: string | null;
        lob?: string | null;
        entitlements?: Array<{
          __typename?: 'WamUserEntitlement';
          name?: string | null;
          description?: string | null;
          functions?: Array<{
            __typename?: 'WamUserFunction';
            name?: string | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type PatientDetailsQueryVariablesGQL = Exact<{
  patientCompositeKeyInput: PatientCompositeKeyInputGQL;
}>;

export type PatientDetailsQueryGQL = {
  __typename?: 'Query';
  patientByCompositeKey?: {
    __typename?: 'Patient';
    asOfDate: string;
    detail?: {
      __typename?: 'PatientDetail';
      alliances?: {
        __typename?: 'PatientAlliance';
        hasMVP?: boolean | null;
        partners?: Array<{
          __typename?: 'Partner';
          roleOfCigna?: string | null;
          effectiveOn?: string | null;
          endsOn?: string | null;
          coordinatingParty?: string | null;
          supportingParty?: string | null;
          thirdPartyAdmin?: string | null;
        } | null> | null;
      } | null;
      cobDetails?: Array<{
        __typename?: 'CobDetail';
        policyNo?: string | null;
        verifiedOn?: string | null;
        effectiveFrom?: string | null;
        effectiveTill?: string | null;
        carrier?: string | null;
        coverageType?: string | null;
        primacy?: string | null;
      } | null> | null;
      subscriberDetails?: {
        __typename?: 'PatientSubscriberDetails';
        firstName?: string | null;
        middleName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        dob?: string | null;
        gender?: string | null;
        internalProcessingId?: string | null;
      } | null;
      serviceContact?: Array<{
        __typename?: 'PatientServiceContact';
        type?: string | null;
        name?: string | null;
        id?: string | null;
        effectiveDate?: string | null;
        group?: string | null;
        web?: string | null;
        webName?: string | null;
        addresses?: Array<{
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          lines?: Array<string | null> | null;
          state?: string | null;
          type?: string | null;
          zip?: string | null;
        } | null> | null;
        phones?: Array<{
          __typename?: 'Phone';
          number?: string | null;
          type?: string | null;
        } | null> | null;
      } | null> | null;
      coverageDetails?: {
        __typename?: 'PatientCoverageDetail';
        accountNumber?: string | null;
        accountName?: string | null;
        clientId?: string | null;
        effectiveFrom?: string | null;
        effectiveTill?: string | null;
        initialCoverageDate?: string | null;
        status?: string | null;
        coverageStatus?: string | null;
        hasPRN?: boolean | null;
        hasPDP?: boolean | null;
        hasIFP?: boolean | null;
        hasCSN?: boolean | null;
        hasMHSR?: boolean | null;
        hasBayCareGroup?: boolean | null;
        coverageType?: string | null;
        networkDescription?: string | null;
        otherInsurance?: string | null;
        otherInsuranceVerifiedOn?: string | null;
        pediatricInd?: string | null;
        utilizationDataNotAvlble?: boolean | null;
        isMultipleCoverage?: boolean | null;
        hasMultipleActive?: boolean | null;
        hasCoveredBenefits?: boolean | null;
        coverages?: Array<string | null> | null;
        isAccountRestricted?: boolean | null;
        medicalManagementPlan?: string | null;
        referralCode?: string | null;
        hasConflictingStatus?: boolean | null;
        erisaApplicable?: boolean | null;
        ohip?: string | null;
        umAuthSystem?: string | null;
        claimSystemCode?: string | null;
        medicare?: {
          __typename?: 'MedicareDetails';
          contractNumber?: string | null;
          groupNumber?: string | null;
          planBenefitPackageNumber?: string | null;
          segmentNumber?: string | null;
          healthPlanName?: string | null;
          operationalMarket?: string | null;
          regulatoryMarket?: string | null;
          specialNeedPlanType?: string | null;
          egwpIndicator?: string | null;
          pcpRequired?: string | null;
          cobDetails?: Array<{
            __typename?: 'CobDetail';
            policyNo?: string | null;
            verifiedOn?: string | null;
            effectiveFrom?: string | null;
            effectiveTill?: string | null;
            carrier?: string | null;
            coverageType?: string | null;
            primacy?: string | null;
          } | null> | null;
        } | null;
        networkDetails?: {
          __typename?: 'NetworkDetails';
          inOutIndicator?: string | null;
          networkId?: string | null;
          networkName?: string | null;
          networkType?: string | null;
          effectiveFrom?: string | null;
          effectiveTill?: string | null;
          superNetworkId?: string | null;
          npoId?: string | null;
          npoName?: string | null;
          mpoId?: string | null;
          mpoName?: string | null;
          porgId?: string | null;
          seamlessIndicator?: string | null;
          baseNetworkId?: string | null;
          iCareNetworkId?: string | null;
          dnspEligible?: string | null;
          isAllegianceMember?: boolean | null;
          isHAPMember?: boolean | null;
          isNetworkTiered?: boolean | null;
          tier?: {
            __typename?: 'Tier';
            tier1?: string | null;
            tier2?: string | null;
          } | null;
          pcp?: {
            __typename?: 'PcpStatus';
            pcpStatus?: string | null;
            hasPCP?: boolean | null;
            assignmentType?: string | null;
            effectiveDate?: string | null;
            cancelDate?: string | null;
            providerIdentity?: {
              __typename?: 'ProviderIdentity';
              id?: string | null;
              type?: string | null;
            } | null;
          } | null;
          hmoDetails?: {
            __typename?: 'HmoDetails';
            orgName?: string | null;
            code?: string | null;
            networkLob?: string | null;
            lob?: string | null;
            networkId?: string | null;
            networkIdCode?: string | null;
            networkDesc?: string | null;
            contact?: {
              __typename?: 'Contact';
              name?: string | null;
              type?: string | null;
              addresses?: Array<{
                __typename?: 'Address';
                city?: string | null;
                country?: string | null;
                lines?: Array<string | null> | null;
                state?: string | null;
                type?: string | null;
                zip?: string | null;
              } | null> | null;
              phones?: Array<{
                __typename?: 'Phone';
                number?: string | null;
                type?: string | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        plan?: {
          __typename?: 'PatientPlan';
          effectiveFrom?: string | null;
          effectiveTill?: string | null;
          type?: string | null;
          fundingType?: string | null;
          isIndemnity?: boolean | null;
          progressiveRegressiveInd?: string | null;
          deductibleSequence?: string | null;
          benefitOption?: string | null;
          branch?: string | null;
          rxCarveOutVendor?: string | null;
          classNumber?: string | null;
          planVariationIdentifier?: string | null;
          pathwellIndicator?: string | null;
          planYears?: {
            __typename?: 'PatientPlanYears';
            effectiveFrom?: string | null;
            effectiveTill?: string | null;
            renewalType?: string | null;
          } | null;
        } | null;
      } | null;
      patientDetails?: {
        __typename?: 'PatientInformation';
        firstName?: string | null;
        middleName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        dob?: string | null;
        gender?: string | null;
        internalProcessingId?: string | null;
        eligibleForCostEstimation?: boolean | null;
        id?: string | null;
        idCardExtensionCode?: string | null;
        identifier?: string | null;
        isInternationalMember?: boolean | null;
        isPolicyHolder?: boolean | null;
        relationship?: string | null;
        addresses?: Array<{
          __typename?: 'Address';
          city?: string | null;
          country?: string | null;
          lines?: Array<string | null> | null;
          state?: string | null;
          type?: string | null;
          zip?: string | null;
        } | null> | null;
      } | null;
      productDetails?: {
        __typename?: 'PatientProductDetail';
        typeCode?: string | null;
        familyCode?: string | null;
        hraFundBalance?: string | null;
        isV2V?: boolean | null;
        isIFP?: boolean | null;
        hasHRA?: boolean | null;
        hasHSA?: boolean | null;
        hasFSA?: boolean | null;
        name?: string | null;
        embeddedProducts?: Array<{
          __typename?: 'PatientProductEmbedded';
          productCode?: string | null;
          effectiveOn?: string | null;
          endsOn?: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type PatientPcpQueryVariablesGQL = Exact<{
  patientCompositeKeyInput: PatientCompositeKeyInputGQL;
  pcpDetailsInput?: InputMaybe<PcpDetailsInputGQL>;
}>;

export type PatientPcpQueryGQL = {
  __typename?: 'Query';
  patientByCompositeKey?: {
    __typename?: 'Patient';
    primaryCareDetails?: {
      __typename?: 'PcpDetails';
      hasPCP?: boolean | null;
      pcpStatus?: string | null;
      primaryCarePhysician?: {
        __typename?: 'PrimaryCareService';
        firstName?: string | null;
        middleName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        effectiveFrom?: string | null;
        effectiveTill?: string | null;
        assignmentType?: string | null;
        addresses?: Array<{
          __typename?: 'Address';
          type?: string | null;
          lines?: Array<string | null> | null;
          city?: string | null;
          country?: string | null;
          state?: string | null;
          zip?: string | null;
        } | null> | null;
        phones?: Array<{
          __typename?: 'Phone';
          number?: string | null;
          type?: string | null;
        } | null> | null;
      } | null;
      providerOrganization?: {
        __typename?: 'ProviderOrganization';
        name?: string | null;
        groupNumber?: string | null;
        serviceTypeCode?: string | null;
        addresses?: Array<{
          __typename?: 'Address';
          type?: string | null;
          lines?: Array<string | null> | null;
          city?: string | null;
          country?: string | null;
          state?: string | null;
          zip?: string | null;
        } | null> | null;
        phones?: Array<{
          __typename?: 'Phone';
          number?: string | null;
          type?: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type PatientAccumsQueryVariablesGQL = Exact<{
  patientCompositeKeyInput: PatientCompositeKeyInputGQL;
  planLevelAccumInput?: InputMaybe<PlanLevelAccumInputGQL>;
}>;

export type PatientAccumsQueryGQL = {
  __typename?: 'Query';
  patientByCompositeKey?: {
    __typename?: 'Patient';
    planLevelAccumulation?: Array<{
      __typename?: 'PlanLevelAccum';
      type?: string | null;
      notes?: Array<string | null> | null;
      benefits?: {
        __typename?: 'PlanLevelAccumBenefits';
        deductible?: {
          __typename?: 'PlanLevelAccumDetail';
          accumulations?: Array<{
            __typename?: 'Accumulation';
            amount?: string | null;
            met?: string | null;
            remaining?: string | null;
            covers?: string | null;
            notes?: Array<string | null> | null;
            cignaCareNetwork?: boolean | null;
            tier?: string | null;
            desc?: string | null;
            networkType?: string | null;
            coveredServices?: Array<string | null> | null;
            tierIndex?: string | null;
            productType?: string | null;
            planPeriodCode?: string | null;
            networkTierLabelName?: string | null;
            networkTierDisplayOrderCdDescription?: string | null;
            networkTierDisplayOrderCd?: string | null;
            networkId?: string | null;
            networkName?: string | null;
          } | null> | null;
        } | null;
        moop?: {
          __typename?: 'PlanLevelAccumDetail';
          accumulations?: Array<{
            __typename?: 'Accumulation';
            amount?: string | null;
            met?: string | null;
            remaining?: string | null;
            covers?: string | null;
            notes?: Array<string | null> | null;
            cignaCareNetwork?: boolean | null;
            tier?: string | null;
            desc?: string | null;
            networkType?: string | null;
            coveredServices?: Array<string | null> | null;
            tierIndex?: string | null;
            productType?: string | null;
            planPeriodCode?: string | null;
            networkTierLabelName?: string | null;
            networkTierDisplayOrderCdDescription?: string | null;
            networkTierDisplayOrderCd?: string | null;
            networkId?: string | null;
            networkName?: string | null;
          } | null> | null;
        } | null;
        coinsurance?: {
          __typename?: 'PlanLevelAccumDetail';
          accumulations?: Array<{
            __typename?: 'Accumulation';
            amount?: string | null;
            met?: string | null;
            remaining?: string | null;
            covers?: string | null;
            notes?: Array<string | null> | null;
            cignaCareNetwork?: boolean | null;
            tier?: string | null;
            desc?: string | null;
            networkType?: string | null;
            coveredServices?: Array<string | null> | null;
            tierIndex?: string | null;
            productType?: string | null;
            planPeriodCode?: string | null;
            networkTierLabelName?: string | null;
            networkTierDisplayOrderCdDescription?: string | null;
            networkTierDisplayOrderCd?: string | null;
            networkId?: string | null;
            networkName?: string | null;
          } | null> | null;
        } | null;
        lifeTimeMaximum?: {
          __typename?: 'PlanLevelAccumDetail';
          accumulations?: Array<{
            __typename?: 'Accumulation';
            amount?: string | null;
            met?: string | null;
            remaining?: string | null;
            covers?: string | null;
            notes?: Array<string | null> | null;
            cignaCareNetwork?: boolean | null;
            tier?: string | null;
            desc?: string | null;
            networkType?: string | null;
            coveredServices?: Array<string | null> | null;
            tierIndex?: string | null;
            productType?: string | null;
            planPeriodCode?: string | null;
            networkTierLabelName?: string | null;
            networkTierDisplayOrderCdDescription?: string | null;
            networkTierDisplayOrderCd?: string | null;
            networkId?: string | null;
            networkName?: string | null;
          } | null> | null;
        } | null;
        outOfPocketMaximum?: {
          __typename?: 'PlanLevelAccumDetail';
          accumulations?: Array<{
            __typename?: 'Accumulation';
            amount?: string | null;
            met?: string | null;
            remaining?: string | null;
            covers?: string | null;
            notes?: Array<string | null> | null;
            cignaCareNetwork?: boolean | null;
            tier?: string | null;
            desc?: string | null;
            networkType?: string | null;
            coveredServices?: Array<string | null> | null;
            tierIndex?: string | null;
            productType?: string | null;
            planPeriodCode?: string | null;
            networkTierLabelName?: string | null;
            networkTierDisplayOrderCdDescription?: string | null;
            networkTierDisplayOrderCd?: string | null;
            networkId?: string | null;
            networkName?: string | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type FlagPatientUpdateMutationVariablesGQL = Exact<{
  patientFlags:
    | Array<InputMaybe<FlagPatientInputGQL>>
    | InputMaybe<FlagPatientInputGQL>;
  type: FlagTypeGQL;
}>;

export type FlagPatientUpdateMutationGQL = {
  __typename?: 'Mutation';
  flagPatientsUpdate?: Array<{
    __typename?: 'FlaggedPatient';
    ami?: string | null;
    asOfDate?: string | null;
    dateFlagged?: string | null;
    dob?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    patientId?: string | null;
    coverage?: {
      __typename?: 'FlaggedPatientCoverage';
      account?: string | null;
      clientName?: string | null;
      compositeKey?: string | null;
      coverageFrom?: string | null;
      coverageStatus?: string | null;
      coverageTo?: string | null;
      coverageType?: string | null;
      isEffectivelyTermed?: boolean | null;
      isInactive?: boolean | null;
      showLink?: boolean | null;
    } | null;
  } | null> | null;
};

export type FlagClaimUpdateMutationVariablesGQL = Exact<{
  claimsFlags:
    | Array<InputMaybe<FlagClaimInputGQL>>
    | InputMaybe<FlagClaimInputGQL>;
  type: FlagTypeGQL;
}>;

export type FlagClaimUpdateMutationGQL = {
  __typename?: 'Mutation';
  flagClaimsUpdate?: Array<{
    __typename?: 'FlaggedClaim';
    id?: string | null;
    tinNumbers?: Array<string | null> | null;
    dateFlagged?: string | null;
    member?: {
      __typename?: 'FlaggedClaimMember';
      memberId?: string | null;
      memberFirstName?: string | null;
      memberLastName?: string | null;
    } | null;
    claimSummary?: {
      __typename?: 'FlaggedClaimSummary';
      chargeAmount?: string | null;
      claimCompositeKey?: string | null;
      claimReferenceNumber?: string | null;
      compositeClaimId?: string | null;
      claimStatus?: string | null;
      dateOfService?: string | null;
      medicare?: boolean | null;
      providerGeneratedAccountNumber?: string | null;
    } | null;
  } | null> | null;
};

export type SaveRecentClaimMutationVariablesGQL = Exact<{
  claim: RecentClaimInputGQL;
}>;

export type SaveRecentClaimMutationGQL = {
  __typename?: 'Mutation';
  saveRecentClaim?: {
    __typename?: 'RecentClaim';
    tinNumbers?: Array<string | null> | null;
    member?: {
      __typename?: 'RecentClaimMember';
      memberId?: string | null;
      memberFirstName?: string | null;
      memberLastName?: string | null;
      memberSearchKey?: string | null;
    } | null;
    claimSummary?: {
      __typename?: 'RecentClaimSummary';
      chargeAmount?: string | null;
      claimCompositeKey?: string | null;
      claimReferenceNumber?: string | null;
      compositeClaimId?: string | null;
      claimStatus?: string | null;
      dateOfService?: string | null;
      medicare?: boolean | null;
      providerGeneratedAccountNumber?: string | null;
    } | null;
  } | null;
};

export const DashboardClaimsDocumentGQL = gql`
  query DashboardClaims {
    recentClaims {
      tinNumbers
      member {
        memberId
        memberFirstName
        memberLastName
      }
      claimSummary {
        chargeAmount
        claimCompositeKey
        claimReferenceNumber
        compositeClaimId
        claimStatus
        dateOfService
        medicare
        providerGeneratedAccountNumber
      }
    }
    flaggedClaims {
      id
      tinNumbers
      dateFlagged
      member {
        memberId
        memberFirstName
        memberLastName
      }
      claimSummary {
        chargeAmount
        claimCompositeKey
        claimReferenceNumber
        compositeClaimId
        claimStatus
        dateOfService
        medicare
        providerGeneratedAccountNumber
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DashboardClaimsGQLService extends Apollo.Query<
  DashboardClaimsQueryGQL,
  DashboardClaimsQueryVariablesGQL
> {
  document = DashboardClaimsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClaimDetailDocumentGQL = gql`
  query ClaimDetail($input: ClaimDetailInput!) {
    getClaimDetail(input: $input) {
      memberObject {
        memberId
        memberDateOfBirth
        memberFirstName
        memberLastName
        relationShipCode
        memberIdentifier
        claimSystemCode
        hasBehavioral
        hasRestrictedAccount
        hasRestrictedGroup
        isPayerSolution
        isSharedAdmin
        notes
        patientId
      }
      claimInfoObject {
        serviceProvider
        claimDateOfService
        claimTotChargeAmount
        claimReferenceNumber
        compositeClaimId
        claimDetailsInfoMessages {
          claimInfoText
        }
        groupNumber
        coverageCompositeKey
        uploadUrl
        isWebster
        isDDAR
        isDOSEstimate
        claimEngineClaimID
        networkPPOIndicator
        firstName
        lastName
        dateOfBirth
        ssn
        ami
        idCardExtensionCode
        providerGeneratedAccountNumber
        isBehavioral
        claimReceivedDate
        claimProcessedDate
        claimDrgUsedCode
        patientResponsibility
        claimTotPaidAmount
        additionalRemarks
        footNoteMessages
        isZelis
        showPaymentInfo
        remarkCodes {
          remarkCode
          desc
        }
        hasReconAccess
        claimAmountDue
        recoupedAmount
        claimAmountPaid
        paymentProviderAmt
        hsaAmount
        hraAmount
        fsaAmount
        haaAmount
        hfAmount
        lpAmount
        claimStatusDesc
        claimStatusCodes {
          statusCodeValue
          statusCodeDesc
          reasonCodeValue
          reasonCodeDesc
        }
        sourceSystemCode
        overPaidClaimsInfo {
          claimReferenceNumber
          patientAccountNumber
          claimPaidDate
          recoupmentAmount
          recoupmentBalance
        }
        payeeInfo {
          eftExists
          chkExists
          payeeName
          payeeAddress
          checkAmount
          checkNumber
          checkStatus
          checkIssuedDate
          checkClearedDate
          paymentMethod
          sourceDataKey
          remittanceNumber
        }
        payeePaymentInfoMessages {
          paymentInfoText
        }
        paymentInfoMessages {
          label
          value
        }
        serviceLineInfoArray {
          id
          isDOSEstimate
          dateOfService
          cdtCode
          procedureCode
          toothNumber
          amountCharged
          svcLineContractedAmount
          svcLinePaidAmount
          placeOfService
          allowedAmount
          serviceLineApcCode
          amountNotCovered
          deductible
          coveredBalance
          planCoInsurancePer
          memberCoInsurancePer
          memberCoInsu
          memberResponsibility
          patientCoinsuranceResponsibility
          copay
          remarkCode
          propRemarkDescription
          hraPayment
          hsaPayment
          fsaPayment
          haPayment
          amountNotAllowed
        }
        serviceLineTotalsObject {
          amountChargedTotal
          allowedAmountTotal
          amountNotCoveredTotal
          deductibleTotal
          coveredBalTotal
          contractedAmountTotal
          coordinationBenefitTotal
          planCoinsurancePaidTotal
          coPayTotal
          memberCoInsuTotal
          memberResponseTotal
          paidFromHATotal
          paidFromHSATotal
          paidFromHRATotal
          paidFromFSATotal
        }
        explanationOfRemarkCodes {
          remarkCode
          remarkCodeDesc
          additionalDesc
        }
      }
      claimCompositeKey
      medicare
      isFlagged
      claimDetailErrorMessage
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClaimDetailGQLService extends Apollo.Query<
  ClaimDetailQueryGQL,
  ClaimDetailQueryVariablesGQL
> {
  document = ClaimDetailDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ClaimDetailNewDocumentGQL = gql`
  query ClaimDetailNew($input: ClaimDetailInput!) {
    claimByCompositeKey(input: $input) {
      remittanceSummaryData {
        isNPINumber
        remittanceData {
          documentType
          remittanceTrackingNumber
          creationDate
          paymentDate
          processedDate
          generatedDate
          reportCategory
          readRemittance
          taxId
          npiList
          depositDate
          depositAmount
          mbrLastName
          mbrFirstName
          mbrDateofBirth
          productType
          expirationDate
          documentTypeStr
          numberOfPages
          links
          pagesList
          dataPowerLink
          docId
          controlStr
          ddarMaxpages
        }
      }
      detail {
        memberObject {
          memberId
          memberDateOfBirth
          memberFirstName
          memberLastName
          relationShipCode
          memberIdentifier
          claimSystemCode
          hasBehavioral
          hasRestrictedAccount
          hasRestrictedGroup
          isPayerSolution
          isSharedAdmin
          notes
          patientId
        }
        claimInfoObject {
          serviceProvider
          claimDateOfService
          claimTotChargeAmount
          claimReferenceNumber
          compositeClaimId
          claimDetailsInfoMessages {
            claimInfoText
          }
          groupNumber
          coverageCompositeKey
          uploadUrl
          isWebster
          isDDAR
          isDOSEstimate
          claimEngineClaimID
          networkPPOIndicator
          firstName
          lastName
          dateOfBirth
          ssn
          ami
          idCardExtensionCode
          providerGeneratedAccountNumber
          isBehavioral
          claimReceivedDate
          claimProcessedDate
          claimDrgUsedCode
          patientResponsibility
          claimTotPaidAmount
          additionalRemarks
          footNoteMessages
          isZelis
          showPaymentInfo
          remarkCodes {
            remarkCode
            desc
          }
          hasReconAccess
          claimAmountDue
          recoupedAmount
          claimAmountPaid
          paymentProviderAmt
          hsaAmount
          hraAmount
          fsaAmount
          haaAmount
          hfAmount
          lpAmount
          claimStatusDesc
          claimStatusCodes {
            statusCodeValue
            statusCodeDesc
            reasonCodeValue
            reasonCodeDesc
          }
          sourceSystemCode
          overPaidClaimsInfo {
            claimReferenceNumber
            patientAccountNumber
            claimPaidDate
            recoupmentAmount
            recoupmentBalance
          }
          payeeInfo {
            eftExists
            chkExists
            payeeName
            payeeAddress
            checkAmount
            checkNumber
            checkStatus
            checkIssuedDate
            checkClearedDate
            paymentMethod
            sourceDataKey
            remittanceNumber
          }
          payeePaymentInfoMessages {
            paymentInfoText
          }
          paymentInfoMessages {
            label
            value
          }
          serviceLineInfoArray {
            id
            isDOSEstimate
            dateOfService
            cdtCode
            procedureCode
            toothNumber
            amountCharged
            svcLineContractedAmount
            svcLinePaidAmount
            placeOfService
            allowedAmount
            serviceLineApcCode
            amountNotCovered
            deductible
            coveredBalance
            planCoInsurancePer
            memberCoInsurancePer
            memberCoInsu
            memberResponsibility
            patientCoinsuranceResponsibility
            copay
            remarkCode
            propRemarkDescription
            hraPayment
            hsaPayment
            fsaPayment
            haPayment
            amountNotAllowed
          }
          serviceLineTotalsObject {
            amountChargedTotal
            allowedAmountTotal
            amountNotCoveredTotal
            deductibleTotal
            coveredBalTotal
            contractedAmountTotal
            coordinationBenefitTotal
            planCoinsurancePaidTotal
            coPayTotal
            memberCoInsuTotal
            memberResponseTotal
            paidFromHATotal
            paidFromHSATotal
            paidFromHRATotal
            paidFromFSATotal
          }
          explanationOfRemarkCodes {
            remarkCode
            remarkCodeDesc
            additionalDesc
          }
          internallyPended
        }
        claimCompositeKey
        medicare
        isFlagged
        claimDetailErrorMessage
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClaimDetailNewGQLService extends Apollo.Query<
  ClaimDetailNewQueryGQL,
  ClaimDetailNewQueryVariablesGQL
> {
  document = ClaimDetailNewDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DashboardPatientsDocumentGQL = gql`
  query DashboardPatients {
    recentPatients {
      ami
      asOfDate
      coverage {
        account
        clientName
        compositeKey
        coverageFrom
        coverageStatus
        coverageTo
        coverageType
        isEffectivelyTermed
        isInactive
        showLink
      }
      dob
      firstName
      lastName
      identifier
      patientId
    }
    flaggedPatients {
      ami
      asOfDate
      coverage {
        account
        clientName
        compositeKey
        coverageFrom
        coverageStatus
        coverageTo
        coverageType
        isEffectivelyTermed
        isInactive
        showLink
      }
      dateFlagged
      dob
      firstName
      lastName
      patientId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DashboardPatientsGQLService extends Apollo.Query<
  DashboardPatientsQueryGQL,
  DashboardPatientsQueryVariablesGQL
> {
  document = DashboardPatientsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FlaggedPatientIdsDocumentGQL = gql`
  query FlaggedPatientIds {
    flaggedPatients {
      coverage {
        compositeKey
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FlaggedPatientIdsGQLService extends Apollo.Query<
  FlaggedPatientIdsQueryGQL,
  FlaggedPatientIdsQueryVariablesGQL
> {
  document = FlaggedPatientIdsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FlaggedClaimIdsDocumentGQL = gql`
  query FlaggedClaimIds {
    flaggedClaims {
      id
      claimSummary {
        claimReferenceNumber
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FlaggedClaimIdsGQLService extends Apollo.Query<
  FlaggedClaimIdsQueryGQL,
  FlaggedClaimIdsQueryVariablesGQL
> {
  document = FlaggedClaimIdsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DashboardWamUsersDocumentGQL = gql`
  query DashboardWamUsers($input: WamUserSearchInput) {
    wamDashboardUsers(input: $input) {
      total
      users {
        firstName
        lastName
        id
        temporaryUserName
        temporaryPassword
        email
        phone
        jobRole
        tins {
          tin
          name
          status
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DashboardWamUsersGQLService extends Apollo.Query<
  DashboardWamUsersQueryGQL,
  DashboardWamUsersQueryVariablesGQL
> {
  document = DashboardWamUsersDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DashboardWamUserDetailDocumentGQL = gql`
  query DashboardWamUserDetail($input: WamUserSearchInput!) {
    wamDashboardUsers(input: $input) {
      users {
        firstName
        lastName
        id
        tinsWithEntitlements {
          tin
          name
          status
          lob
          entitlements {
            name
            description
            functions {
              name
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DashboardWamUserDetailGQLService extends Apollo.Query<
  DashboardWamUserDetailQueryGQL,
  DashboardWamUserDetailQueryVariablesGQL
> {
  document = DashboardWamUserDetailDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientDetailsDocumentGQL = gql`
  query PatientDetails($patientCompositeKeyInput: PatientCompositeKeyInput!) {
    patientByCompositeKey(input: $patientCompositeKeyInput) {
      asOfDate
      detail {
        alliances {
          hasMVP
          partners {
            roleOfCigna
            effectiveOn
            endsOn
            coordinatingParty
            supportingParty
            thirdPartyAdmin
          }
        }
        cobDetails {
          policyNo
          verifiedOn
          effectiveFrom
          effectiveTill
          carrier
          coverageType
          primacy
        }
        subscriberDetails {
          firstName
          middleName
          lastName
          fullName
          dob
          gender
          internalProcessingId
        }
        serviceContact {
          type
          name
          addresses {
            city
            country
            lines
            state
            type
            zip
          }
          phones {
            number
            type
          }
          id
          effectiveDate
          group
          web
          webName
        }
        coverageDetails {
          accountNumber
          accountName
          clientId
          effectiveFrom
          effectiveTill
          initialCoverageDate
          status
          coverageStatus
          hasPRN
          hasPDP
          hasIFP
          hasCSN
          hasMHSR
          hasBayCareGroup
          coverageType
          networkDescription
          otherInsurance
          otherInsuranceVerifiedOn
          pediatricInd
          utilizationDataNotAvlble
          isMultipleCoverage
          hasMultipleActive
          hasCoveredBenefits
          coverages
          isAccountRestricted
          medicalManagementPlan
          medicare {
            contractNumber
            groupNumber
            planBenefitPackageNumber
            segmentNumber
            healthPlanName
            operationalMarket
            regulatoryMarket
            specialNeedPlanType
            egwpIndicator
            cobDetails {
              policyNo
              verifiedOn
              effectiveFrom
              effectiveTill
              carrier
              coverageType
              primacy
            }
            pcpRequired
          }
          networkDetails {
            inOutIndicator
            networkId
            networkName
            networkType
            effectiveFrom
            effectiveTill
            superNetworkId
            npoId
            npoName
            mpoId
            mpoName
            porgId
            seamlessIndicator
            baseNetworkId
            iCareNetworkId
            dnspEligible
            tier {
              tier1
              tier2
            }
            pcp {
              providerIdentity {
                id
                type
              }
              pcpStatus
              hasPCP
              assignmentType
              effectiveDate
              cancelDate
            }
            hmoDetails {
              orgName
              code
              networkLob
              lob
              networkId
              networkIdCode
              networkDesc
              contact {
                name
                addresses {
                  city
                  country
                  lines
                  state
                  type
                  zip
                }
                phones {
                  number
                  type
                }
                type
              }
            }
            isAllegianceMember
            isHAPMember
            isNetworkTiered
          }
          referralCode
          hasConflictingStatus
          erisaApplicable
          ohip
          umAuthSystem
          claimSystemCode
          plan {
            effectiveFrom
            effectiveTill
            type
            fundingType
            isIndemnity
            progressiveRegressiveInd
            deductibleSequence
            benefitOption
            branch
            rxCarveOutVendor
            classNumber
            planVariationIdentifier
            pathwellIndicator
            planYears {
              effectiveFrom
              effectiveTill
              renewalType
            }
          }
        }
        patientDetails {
          firstName
          middleName
          lastName
          fullName
          dob
          gender
          internalProcessingId
          addresses {
            city
            country
            lines
            state
            type
            zip
          }
          eligibleForCostEstimation
          id
          idCardExtensionCode
          identifier
          isInternationalMember
          isPolicyHolder
          relationship
        }
        productDetails {
          typeCode
          familyCode
          hraFundBalance
          isV2V
          isIFP
          hasHRA
          hasHSA
          hasFSA
          embeddedProducts {
            productCode
            effectiveOn
            endsOn
          }
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientDetailsGQLService extends Apollo.Query<
  PatientDetailsQueryGQL,
  PatientDetailsQueryVariablesGQL
> {
  document = PatientDetailsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientPcpDocumentGQL = gql`
  query PatientPcp(
    $patientCompositeKeyInput: PatientCompositeKeyInput!
    $pcpDetailsInput: PcpDetailsInput
  ) {
    patientByCompositeKey(input: $patientCompositeKeyInput) {
      primaryCareDetails(input: $pcpDetailsInput) {
        hasPCP
        pcpStatus
        primaryCarePhysician {
          firstName
          middleName
          lastName
          fullName
          addresses {
            type
            lines
            city
            country
            state
            zip
          }
          phones {
            number
            type
          }
          effectiveFrom
          effectiveTill
          assignmentType
        }
        providerOrganization {
          name
          groupNumber
          serviceTypeCode
          addresses {
            type
            lines
            city
            country
            state
            zip
          }
          phones {
            number
            type
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientPcpGQLService extends Apollo.Query<
  PatientPcpQueryGQL,
  PatientPcpQueryVariablesGQL
> {
  document = PatientPcpDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PatientAccumsDocumentGQL = gql`
  query PatientAccums(
    $patientCompositeKeyInput: PatientCompositeKeyInput!
    $planLevelAccumInput: PlanLevelAccumInput
  ) {
    patientByCompositeKey(input: $patientCompositeKeyInput) {
      planLevelAccumulation(input: $planLevelAccumInput) {
        type
        notes
        benefits {
          deductible {
            accumulations {
              amount
              met
              remaining
              covers
              notes
              cignaCareNetwork
              tier
              desc
              networkType
              coveredServices
              tierIndex
              productType
              planPeriodCode
              networkTierLabelName
              networkTierDisplayOrderCdDescription
              networkTierDisplayOrderCd
              networkId
              networkName
            }
          }
          moop {
            accumulations {
              amount
              met
              remaining
              covers
              notes
              cignaCareNetwork
              tier
              desc
              networkType
              coveredServices
              tierIndex
              productType
              planPeriodCode
              networkTierLabelName
              networkTierDisplayOrderCdDescription
              networkTierDisplayOrderCd
              networkId
              networkName
            }
          }
          coinsurance {
            accumulations {
              amount
              met
              remaining
              covers
              notes
              cignaCareNetwork
              tier
              desc
              networkType
              coveredServices
              tierIndex
              productType
              planPeriodCode
              networkTierLabelName
              networkTierDisplayOrderCdDescription
              networkTierDisplayOrderCd
              networkId
              networkName
            }
          }
          lifeTimeMaximum {
            accumulations {
              amount
              met
              remaining
              covers
              notes
              cignaCareNetwork
              tier
              desc
              networkType
              coveredServices
              tierIndex
              productType
              planPeriodCode
              networkTierLabelName
              networkTierDisplayOrderCdDescription
              networkTierDisplayOrderCd
              networkId
              networkName
            }
          }
          outOfPocketMaximum {
            accumulations {
              amount
              met
              remaining
              covers
              notes
              cignaCareNetwork
              tier
              desc
              networkType
              coveredServices
              tierIndex
              productType
              planPeriodCode
              networkTierLabelName
              networkTierDisplayOrderCdDescription
              networkTierDisplayOrderCd
              networkId
              networkName
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PatientAccumsGQLService extends Apollo.Query<
  PatientAccumsQueryGQL,
  PatientAccumsQueryVariablesGQL
> {
  document = PatientAccumsDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FlagPatientUpdateDocumentGQL = gql`
  mutation FlagPatientUpdate(
    $patientFlags: [FlagPatientInput]!
    $type: FlagType!
  ) {
    flagPatientsUpdate(patients: $patientFlags, type: $type) {
      ami
      asOfDate
      coverage {
        account
        clientName
        compositeKey
        coverageFrom
        coverageStatus
        coverageTo
        coverageType
        isEffectivelyTermed
        isInactive
        showLink
      }
      dateFlagged
      dob
      firstName
      lastName
      patientId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FlagPatientUpdateGQLService extends Apollo.Mutation<
  FlagPatientUpdateMutationGQL,
  FlagPatientUpdateMutationVariablesGQL
> {
  document = FlagPatientUpdateDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FlagClaimUpdateDocumentGQL = gql`
  mutation FlagClaimUpdate($claimsFlags: [FlagClaimInput]!, $type: FlagType!) {
    flagClaimsUpdate(claims: $claimsFlags, type: $type) {
      id
      tinNumbers
      dateFlagged
      member {
        memberId
        memberFirstName
        memberLastName
      }
      claimSummary {
        chargeAmount
        claimCompositeKey
        claimReferenceNumber
        compositeClaimId
        claimStatus
        dateOfService
        medicare
        providerGeneratedAccountNumber
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FlagClaimUpdateGQLService extends Apollo.Mutation<
  FlagClaimUpdateMutationGQL,
  FlagClaimUpdateMutationVariablesGQL
> {
  document = FlagClaimUpdateDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveRecentClaimDocumentGQL = gql`
  mutation SaveRecentClaim($claim: RecentClaimInput!) {
    saveRecentClaim(claim: $claim) {
      tinNumbers
      member {
        memberId
        memberFirstName
        memberLastName
        memberSearchKey
      }
      claimSummary {
        chargeAmount
        claimCompositeKey
        claimReferenceNumber
        compositeClaimId
        claimStatus
        dateOfService
        medicare
        providerGeneratedAccountNumber
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SaveRecentClaimGQLService extends Apollo.Mutation<
  SaveRecentClaimMutationGQL,
  SaveRecentClaimMutationVariablesGQL
> {
  document = SaveRecentClaimDocumentGQL;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
